import React, { useState, useEffect } from 'react';
import { TaxDocument } from '../../types/user';
import { fetchTaxDocuments } from '../../services/profileService';

export default function TaxCenter() {
  const [docs, setDocs] = useState<TaxDocument[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTaxDocuments()
      .then(setDocs)
      .catch((err: any) => setError(err.message || 'Failed to load tax documents'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="profile-loading">Loading tax documents…</div>;
  if (error) return <div className="profile-error">{error}</div>;

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Tax Center</h3>
      <p className="profile-description">
        Download your tax-relevant transaction exports for use with tax software.
      </p>
      {docs.length === 0 ? (
        <p className="profile-empty">No tax documents available.</p>
      ) : (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Year</th>
              <th>Type</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {docs.map(d => (
              <tr key={d.id}>
                <td>{d.year}</td>
                <td>{d.type}</td>
                <td>
                  <a
                    href={d.downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="profile-link"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
